exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".menu-container--profile[data-v-069a2465]:not(.fullscreen){width:28.6458%}.menu-container--profile:not(.fullscreen).editing[data-v-069a2465]{width:100%}@media (max-width:767px){.menu-container--profile[data-v-069a2465]:not(.fullscreen){width:100%}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-069a2465","scoped":true,"hasInlineConfig":true}!./~/sass-loader/dist/cjs.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/menu/RightMenuWrapper.vue
// module id = c+YE
// module chunks = 0 1